import { fromJS } from 'immutable';
import {
  LOAD_EVENTS_SUCCESS,
  UPDATE_EVENT_SUCCESS,
  TOGGLE_EVENT_VIEW,
  TOGGLE_EVENT_SCHEDULE_FORM,
} from 'constants/ActionTypes';

const initialState = fromJS({
  dataset: [],
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
  view: {
    isVisible: false,
    eventId: null,
  },
});

const eventTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_EVENTS_SUCCESS:
      return state.merge(
        fromJS({
          dataset: action.events.items.map((event) => event.eventId),
          pagination: {
            totalCount: action.events._meta.totalCount,
            pageCount: action.events._meta.pageCount,
            currentPage: action.events._meta.currentPage,
            perPage: action.events._meta.perPage,
          },
        }),
      );
    case UPDATE_EVENT_SUCCESS: {
      return state.set('dataset', state.get('dataset').unshift(action.event.articleId));
    }
    case TOGGLE_EVENT_VIEW: {
      const view = state.get('view');
      if (view.get('eventId') && !view.get('isVisible')) {
        return state;
      }

      return state.set(
        'view',
        fromJS({
          isVisible: !state.getIn(['view', 'isVisible']),
          eventId: action.eventId,
        }),
      );
    }
    case TOGGLE_EVENT_SCHEDULE_FORM: {
      // If open schedule form from view event card
      if (action.viewComponent) {
        return state.setIn(['view', 'isVisible'], false);
      }

      const view = state.get('view');

      // If close schedule for in view event card
      if (!view.get('isVisible') && view.get('eventId')) {
        return state.setIn(['view', 'isVisible'], true);
      }

      return state;
    }
    default:
      return state;
  }
};

export default eventTableReducer;
